//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getIndustry} from '@/assets/js/dict'
export default {
    created(){
        getIndustry().then(res=>{
            this.industrys= res;
        })
    },
    data: () => ({
        industrys:[],
        info:'',
        userIndustryList:[],
        size:'normal',
        headers:{},
        dialogVisible:false,
        avatar:'',
        imgList:[],
        loading:false
    }),
    methods: {

        // 获取个人信息
        getInfo(){
            this.$get('/sys/user/info','',function(res){
                if(res.code==200){
                    this.info=res.data;
                    this.avatar= res.data.avatar
                }
            })
        },

        // 打开弹窗
        openHead(){
            this.dialogVisible= true
        },

         // 获取头像列表
        getHeadInfo(){
            this.$get('/oss/file/avatar', '',function(res){
                if (res.code == 200) {
                    this.imgList= res.data;
                }
            })
        },

        // 选择头像
        chooseImg(item){
            this.avatar= item;
        },


        // 修改头像
        handleAvatarSuccess(ress, file) {
            this.avatar =ress.data.fileUrl;
            this.loading= false
        },
        onProgress(){
            this.loading= true
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.split('/')[0] === 'image';
            const isLt2M = file.size / 1024 / 1024 <10;
            if (!isJPG) {
                this.$message.error('文件只能是图片类型!');
            }
            if (!isLt2M) {
                this.$message.error('文件大小超过 10MB!');
            }
            return isLt2M&&isJPG;
        },

        // 调用保存接口
        saveData(){
            var form ={
                currentUserType: this.info.currentUserType,
                avatar:this.avatar,
                id:this.info.id,
            }
            this.$put('/sys/user/',form,function(res){
                if (res.code == 200) {
                    this.$message.success('修改成功!');
                    this.dialogVisible= false
                    this.getInfo();
                }else{
                    this.$message.error(res.msg)
                }
            },true )
        },

        // 是否公开个人信息
        choosePub(val){
            var form ={
                currentUserType: this.info.currentUserType,
                isPublic:val,
                id:this.info.id,
            }
            this.$put('/sys/user/',form,function(res){
                if (res.code == 200) {
                    this.$message.success('修改成功!');
                    this.getInfo();
                }else{
                    this.$message.error(res.msg)
                }
            },true )
        },

        // 编辑个人信息
        editInfo(){
            this.$router.push({
                path:'/person/editInfo'
            })
        }
       
    },
    mounted() {
       this.getInfo()
       this.getHeadInfo()
        this.headers = {
            "Authorization": 'bearer ' + getSession('token').access_token
        }
    }
}
